
import { Link } from 'react-router-dom';

export default function CategoryNavigation() {
  const categories = [
    {
      title: '初心者向け',
      description: '初めての1枚に最適',
      icon: 'ri-user-smile-line',
      color: 'from-blue-500 to-cyan-500',
      bgColor: 'bg-blue-50',
      link: '/ranking',
      badge: 'おすすめ'
    },
    {
      title: '高還元率',
      description: 'ポイントがザクザク貯まる',
      icon: 'ri-percent-line',
      color: 'from-orange-500 to-amber-500',
      bgColor: 'bg-orange-50',
      link: '/highreturn',
      badge: '人気'
    },
    {
      title: '学生向け',
      description: '学生専用の特典が充実',
      icon: 'ri-graduation-cap-line',
      color: 'from-purple-500 to-pink-500',
      bgColor: 'bg-purple-50',
      link: '/student',
      badge: '学生限定'
    },
    {
      title: '年会費無料',
      description: 'ずっと無料で使える',
      icon: 'ri-money-dollar-circle-line',
      color: 'from-emerald-500 to-teal-500',
      bgColor: 'bg-emerald-50',
      link: '/free',
      badge: '無料'
    },
    {
      title: '即日発行',
      description: '今日から使える',
      icon: 'ri-flashlight-line',
      color: 'from-yellow-500 to-orange-500',
      bgColor: 'bg-yellow-50',
      link: '/instant',
      badge: '最短即日'
    }
  ];

  return (
    <section className="py-12 sm:py-16 md:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        {/* タイトル */}
        <div className="text-center mb-8 sm:mb-12 md:mb-16">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-3 sm:mb-4 px-4">
            目的別に探す
          </h2>
          <p className="text-sm sm:text-base md:text-lg text-gray-600 px-4">
            あなたの目的に合わせて最適なカードを見つけましょう
          </p>
          <div className="w-16 sm:w-20 h-1 bg-gradient-to-r from-teal-500 to-cyan-500 mx-auto mt-4 sm:mt-6 rounded-full"></div>
        </div>

        {/* カテゴリカード - モバイルは2列、タブレット以上は3列 */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-3 sm:gap-5 md:gap-8">
          {categories.map((category, index) => (
            <Link
              key={index}
              to={category.link}
              className={`group relative bg-white rounded-xl sm:rounded-2xl md:rounded-3xl p-4 sm:p-6 md:p-8 shadow-md sm:shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-1 sm:hover:-translate-y-2 overflow-hidden border border-gray-100 hover:border-transparent ${
                index === 4 ? 'col-span-2 md:col-span-1' : ''
              }`}
            >
              {/* 背景グラデーション（ホバー時） */}
              <div className={`absolute inset-0 bg-gradient-to-br ${category.color} opacity-0 group-hover:opacity-5 transition-opacity duration-300`}></div>
              
              {/* バッジ */}
              <div className="absolute top-2 right-2 sm:top-4 sm:right-4">
                <span className={`inline-block bg-gradient-to-r ${category.color} text-white text-[10px] sm:text-xs font-bold px-2 sm:px-3 py-0.5 sm:py-1 rounded-full shadow-md`}>
                  {category.badge}
                </span>
              </div>

              {/* アイコン */}
              <div className={`w-12 h-12 sm:w-16 sm:h-16 md:w-20 md:h-20 rounded-xl sm:rounded-2xl bg-gradient-to-br ${category.color} flex items-center justify-center mb-3 sm:mb-4 md:mb-6 group-hover:scale-105 sm:group-hover:scale-110 group-hover:rotate-3 transition-all duration-300 shadow-md sm:shadow-lg`}>
                <i className={`${category.icon} text-xl sm:text-2xl md:text-4xl text-white`}></i>
              </div>

              {/* テキスト */}
              <h3 className="text-sm sm:text-lg md:text-2xl font-bold text-gray-900 mb-1 sm:mb-2 md:mb-3 group-hover:text-transparent group-hover:bg-clip-text group-hover:bg-gradient-to-r group-hover:from-teal-600 group-hover:to-cyan-600 transition-all duration-300">
                {category.title}
              </h3>
              <p className="text-gray-600 text-xs sm:text-sm md:text-base mb-3 sm:mb-4 md:mb-6 leading-relaxed hidden sm:block">
                {category.description}
              </p>

              {/* 矢印 */}
              <div className="flex items-center text-teal-600 font-semibold group-hover:gap-2 sm:group-hover:gap-3 transition-all duration-300 text-xs sm:text-sm md:text-base">
                <span className="hidden sm:inline">詳しく見る</span>
                <span className="sm:hidden">詳細</span>
                <i className="ri-arrow-right-line text-base sm:text-lg md:text-xl group-hover:translate-x-1 sm:group-hover:translate-x-2 transition-transform duration-300"></i>
              </div>

              {/* 装飾 */}
              <div className={`absolute -bottom-8 -right-8 sm:-bottom-10 sm:-right-10 w-20 h-20 sm:w-32 sm:h-32 rounded-full bg-gradient-to-br ${category.color} opacity-0 group-hover:opacity-10 blur-2xl transition-all duration-500`}></div>
            </Link>
          ))}
        </div>

        {/* 下部CTA */}
        <div className="mt-8 sm:mt-12 md:mt-16 text-center">
          <div className="inline-block bg-gradient-to-r from-gray-50 to-blue-50 rounded-xl sm:rounded-2xl p-5 sm:p-8 shadow-lg w-full sm:w-auto">
            <p className="text-gray-700 mb-3 sm:mb-4 text-sm sm:text-lg px-2">
              <strong className="text-teal-600">まだ迷っている方は</strong>、総合ランキングをチェック！
            </p>
            <Link
              to="/ranking"
              className="inline-flex items-center justify-center gap-2 bg-gradient-to-r from-teal-500 to-cyan-500 hover:from-teal-600 hover:to-cyan-600 text-white font-bold px-6 sm:px-8 py-3 sm:py-4 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105 whitespace-nowrap text-sm sm:text-base w-full sm:w-auto"
            >
              <i className="ri-trophy-line text-lg sm:text-xl"></i>
              <span>総合ランキングを見る</span>
              <i className="ri-arrow-right-line text-base sm:text-lg"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
